export const getMenuItems = (userRole) => {
  if (userRole === 'admin') {
    return [
      { icon: "home", tooltip: "Dashboard", route: { name: "dashboard" } },
      { icon: "user", tooltip: "Manage users", route: { name: "manage-users" } },
      { icon: "dollar", tooltip: "Pricing catalog", route: { name: "pricing-catalog" } },
      { icon: "edit", tooltip: "AI prompts", route: { name: "prompts" } },
      { icon: "file", tooltip: "Knowledge base", route: { name: "documents" } },
      { icon: "log-out", tooltip: "Log out", route: "/logout" },
    ];
  }

  // Regular user menu
  return [
    { icon: "plus", tooltip: "New", route: { name: "new-report" } },
    { icon: "file", tooltip: "Reports", route: { name: "reports" } },
    { icon: "log-out", tooltip: "Log out", route: "/logout" },
  ];
};
